(() => {
  if (window.JMPCollectionTitles) return;

  /*
   * JMP COLLECTION DISPLAY NAMES
   *
   * Left side: original Shopify product title.
   * Right side: the three collection display rows.
   * An empty string "" reserves a blank row.
   *
   * Change the right-hand rows to adjust the displayed name.
   * Add another entry here when adding a new product.
   */
  const RAW_TITLE_LINES = {
    "Addicted to Love Warming Vanilla 100ml/3.4oz": ["Addicted to Love", "Warming Vanilla", "Eau de Parfum"],
    "After Dark Parfum Intense 100ml / 3.4 fl oz": ["After Dark", "Pour Homme", "Parfum Intense"],
    "All My Love Collection Bundle (Value $425)": ["All My Love", "Bundle", ""],
    "Amour Dans Paris Bundle (Value $170)": ["Armour Dans Paris", "Bundle", ""],
    "Apothecary 15 Eau de Parfum Spray 100 ml / 3.4 fl oz": ["Apothecary 15", "Eau de Parfum", ""],
    "Arabian Nights Eau de Parfum 100 ml / 3.4 fl oz": ["Arabiran Nights", "Eau de Parfum", ""],
    "Big Whiskey Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["Big Whiskey", "Pour Homme", "Eau de Toilette"],
    "Black Armour Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["Black Armour", "Pour Homme", "Eau de Toilette"],
    "Black Musk Homme Eau de Toilette Spray 100ml/3.4oz": ["Black Musk", "Pour Homme", "Eau de Toilette"],
    "Black Noir Pour Homme Eau de Toilette 100ml/3.4oz": ["Black Noir", "Pour Homme", "Eau de Toilette"],
    "Bleu De Noir Eau de Toilette Spray 100ml/3.4oz": ["Bleu De Noir", "Pour Homme", "Eau de Toilette"],
    "Bleu Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["Bleu", "Pour Homme", "Eau de Toilette"],
    "Blossoms Peony Eau de Parfum Spray 100ml/3.4oz": ["Blossoms Peony", "Eau de Parfum", ""],
    "Blue Armour Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["Blue Armour", "Pour Homme", "Eau de Toilette"],
    "Blue North 3 in 1 Men's Wash Face Hair Body 34oz/934ml": ["Blue North", "Pour Homme", "3 in 1 Body Care"],
    "Blue North Body Spray 6oz/170g": ["Blue North", "Pour Homme", "Body Spray"],
    "Blue North Deodorant 2.8oz/80g": ["Blue North", "Pour Homme", "Deodorant Stick"],
    "Blue North Pour Homme Body Bar Soap 10oz/284g": ["Blue North", "Pour Homme", "Body Bar Soap"],
    "Blue North Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["Blue North", "Pour Homme", "Eau de Toilette"],
    "Blue North Pour Homme Eau de Toilette Spray 2-Piece Gift Set": ["Blue North", "Pour Homme", "Eau de Toilette"],
    "Bodacious Eau de Parfum 100ml/3.4oz": ["Bodacious", "Eau de Parfum", ""],
    "Bull Rider Eau de Toilette Spray 3.4oz / 100ml": ["Bull Rider", "Pour Homme", "Eau de Toilette"],
    "Candy Apple Eau de Parfum 100ml/3.4oz": ["Candy Apple", "Eau de Parfum", ""],
    "Chateau de Rose Eau de Parfum 100ml/3.4oz": ["Chateau de Rose", "Eau de Parfum", ""],
    "Cherry Martini Kiss Eau de Parfum 100ml/3.4oz": ["Cherry Martini Kiss", "Eau de Parfum", ""],
    "Cherry Shake Eau de Parfum 100 ml / 3.4 fl oz": ["Cherry Shake", "Eau de Parfum", ""],
    "Cherry Vanilla Syrup Eau de Parfum Spray 100 ml / 3.4 fl oz": ["Cherry Vanilla Syrup", "Eau de Parfum", ""],
    "Club Paris Exclusive Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["Club Paris Exclusive", "Pour Homme", "Eau de Toilette"],
    "Club Paris Pour Homme Eau de Parfum Spray 100ml/3.4oz": ["Club Paris", "Pour Homme", "Eau de Parfum"],
    "Country Girl Eau de Parfum Spray 100ml/3.4oz": ["Country Girl", "Eau de Parfum", ""],
    "Cowboy Eau de Toilette Spray 100ml/3.4oz": ["Cowboy", "Pour Homme", "Eau de Toilette"],
    "Cup Winner Eau de Parfum Intense 100ml / 3.4 fl oz": ["Cup Winner", "Intense", "Eau de Parfum"],
    "De Gourmand Chocolate Cream Eau de Parfum 100 ml / 3.4 fl oz": ["De Gourmand", "Chocolate Cream", "Eau de Parfum"],
    "De Gourmand Strawberry Vanilla Cream Eau de Parfum 100ml / 3.4 fl oz": ["De Gourmand", "Strawberry Cream", "Eau de Parfum"],
    "Double Trouble Bundle (Value $139)": ["Double Trouble", "Bundle", ""],
    "Eau de Paris Fraiche Pour Homme Eau de Parfum Spray 100ml/3.4oz": ["Eau de Paris Fraiche", "Pour Homme", "Eau de Parfum"],
    "Eau de Paris Pour Homme Eau de Parfum Spray 100ml/3.4oz": ["Eau de Paris", "Pour Homme", "Eau de Parfum"],
    "Femme Eau de Parfum 100ml/3.4oz": ["Femme", "Eau de Parfum", ""],
    "Femme Noir Body Spray 236ml/8oz": ["Femme Noir", "Eau de Parfum", "Body Spray"],
    "Femme Noir Eau de Parfum Spray 100ml/3.4oz": ["Femme Noir", "Eau de Parfum", ""],
    "Femme Noir Intense Parfum Spray 100 ml / 3.4 fl oz": ["Femme Noir", "Parfum Intense", ""],
    "Femme Noir Signature Bundle (Value $124)": ["Femme Noir Signature", "Bundle", ""],
    "First Class Eau de Toilette Spray 100ml/3.4oz": ["First Class", "Eau de Toilette", ""],
    "Fleur Paris Eau de Parfum Spray 100ml/3.4oz": ["Fleur Paris", "Eau de Parfum", ""],
    "Fleur Paris Noir Eau de Parfum 2-Piece Gift Set": ["Fleur Paris Noir", "Eau de Parfum", "Gift Set"],
    "Fleur Paris Noir Eau de Parfum Spray 50ml/1.7oz": ["Fleur Paris Noir", "Eau de Parfum", ""],
    "Fleur Paris Rose Eau de Parfum Spray 50ml/1.7oz": ["Fleur Paris Rose", "Eau de Parfum", ""],
    "Flirtatious Eau de Parfum 100ml/3.4oz": ["Flirtatious", "Eau de Parfum", ""],
    "French Milled Rose & Grapefruit Soap 10oz/284g": ["French Milled", "Rose & Grapefruit", "Soap Bar"],
    "Fuego Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["Fuego", "Pour Homme", "Eau de Toilette"],
    "Girl Talk Eau de Parfum 100ml/3.4oz": ["Girl Talk", "Eau de Parfum", ""],
    "Glamorous Love Bundle (Value $170)": ["Glamorous Love", "Bundle", ""],
    "Gold Honey Oud Eau de Parfum Spray 3.4oz / 100ml": ["Gold Honey Oud", "Eau de Parfum", ""],
    "High Roller Eau de Toliette Spray 3.4oz / 100ml": ["High Roller", "Eau de Toilette", ""],
    "Homme Eau de Toilette Spray 100ml/3.4oz": ["Homme", "Eau de Toilette", ""],
    "Homme Extreme Eau de Toilette Spray 100ml/3.4oz": ["Homme Extreme", "Eau de Toilette", ""],
    "Homme Extreme Eau de Toilette Spray 50ml/1.7oz": ["Homme Extreme", "Eau de Toilette", ""],
    "Homme Noir 3 in 1 Men's Wash Face Hair Body 34oz/934ml": ["Homme Noir", "3 in 1 Body Care", ""],
    "Homme Noir 365 Essentials Bundle (Value $143)": ["Homme Noir", "365 Essentials", "Bundle"],
    "Homme Noir Beard Oil 1oz/30ml": ["Homme Noir", "Beard Oil", ""],
    "Homme Noir Body Bar Soap 10oz/284g": ["Homme Noir", "Body Bar Soap", ""],
    "Homme Noir Body Spray 6oz/170g": ["Homme Noir", "Body Spray", ""],
    "Homme Noir Dark Spice Parfum Intense 100ml/3.4 fl oz": ["Homme Noir", "Dark Spice", "Parfum Intense"],
    "Homme Noir Deodorant 2.8oz/80g": ["Homme Noir", "Deodorant Stick", ""],
    "Homme Noir Eau de Parfum Spray 100ml/3.4oz": ["Homme Noir", "Eau de Parfum", ""],
    "Homme Noir Eau de Toilette Spray 100ml/3.4oz or 180ml/6oz": ["Homme Noir", "Eau de Toillette", ""],
    "Homme Noir Signature Bundle (Value $108)": ["Homme Noir Signature", "Bundle", ""],
    "I AM HIM 3.4oz / 100 ml Elixer Parfum Spray": ["I AM HIM", "Elixer Parfum", ""],
    "I Love U Candy Apple Eau de Parfum Spray 100ml/3.4oz": ["I Love U Candy Apple", "Eau de Parfum", ""],
    "I Love U Charmed Eau de Parfum Spray 100ml/3.4oz": ["I Love U Charmed", "Eau de Parfum", ""],
    "I Love U Cherry Crush Eau de Parfum Spray 100ml/3.4oz": ["I Love U Cherry Crush", "Eau de Parfum", ""],
    "I Love U Eau de Parfum Spray 100ml/3.4oz": ["I Love U", "Eau de Parfum", ""],
    "I Love U Gold Caramel Eau de Parfum Spray 100ml/3.4oz": ["I Love U", "Gold Caramel", "Eau de Parfum"],
    "I Love You Eternally Bundle (Value $170)": ["I Love You", "Eternally", "Bundle"],
    "I Love You Forever Eau de Parfum Spray 100ml/3.4oz": ["I Love You Forever", "Eau de Parfum", ""],
    "Iron Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["Iron", "Pour homme", "Eau de Toilette"],
    "Jasmine de Paris Eau de Parfum 100ml/3.4oz": ["Jasmine de Paris", "Eau de Parfum", ""],
    "Jean Marc Paris Egift Card": ["Jean Marc Paris", "Egift Card", ""],
    "Jean Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["Jean", "Pour Homme", "Eau de Toilette"],
    "JMP Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["JMP", "Pour Homme", "Eau de Toilette"],
    "Kiss Me Eau de Parfum 100ml/3.4oz": ["Kiss Me", "Eau de Parfum", ""],
    "L'Air de Paris Cote D'Azur Eau de Parfum Spray 100 ml / 3.4 fl oz": ["L'Air de Paris", "Cote D'Azur", "Eau de Parfum"],
    "L'Air de Paris Eau de Parfum 100ml/3.4oz": ["L'Air de Paris", "Eau de Parfum", ""],
    "L'Air de Paris Provence Eau de Parfum Spray 100 ml /3.4 fl oz": ["L'Air de Paris", "Provence", "Eau de Parfum"],
    "L'Homme Super Bundle (Value $158)": ["L'Homme Super", "Bundle", ""],
    "La Femme Noir Bundle (Value $170)": ["La Femme Noir", "Bundle", ""],
    "Love At First Sight Bundle (Value $164)": ["Love At First Sight", "Bundle", ""],
    "Love Me Eau de Parfum 100ml/3.4oz": ["Love Me", "Eau de Parfum", ""],
    "Love Me Tonight Eau de Parfum Spray 100ml/3.4oz": ["Love Me Tonight", "Eau de Parfum", ""],
    "Madly In Love Bundle (Value $170)": ["Madly in Love", "Bundle", ""],
    "Man Care Beard Oil Mist 4oz/120ml": ["Man Care", "Beard Oil Mist", ""],
    "Marc Saint Jean Noir Pour Homme 3.4 oz / 100ml Eu de Toilette": ["Marc Saint Jean", "Pour Homme", "Eau de Toilette"],
    "Maximus Eau de Toilette Spray 100ml/3.4oz": ["Maximus", "Pour Homme", "Eau de Toilette"],
    "Midnight Velvet Eau de Toilette Spray 3.4oz / 100ml": ["Midnight Velvet", "Pour Homme", "Eau de Toilette"],
    "Miss Sexy Eau de Parfum Spray 100ml/3.4oz": ["Miss Sexy", "Eau de Parfum", ""],
    "Mont Noir Eau de toilette 100 ml / 3.4 fl oz": ["Mont Noir", "Pour Homme", "Eau de Toilette"],
    "Mr. Big Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["Mr.Big", "Pour Homme", "Eau de Toilette"],
    "MVP Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["MVP", "Pour Homme", "Eau de Toilette"],
    "New! Dulce de Leche Vanilla Crème 3.4oz / 100ml Eau de Parfum Spray": ["Dulce de Leche", "Vanilla Crème", "Eau de Parfum"],
    "New! Vanilla Marshmallow Dream 3.4oz / 100ml Eau de Parfum Spray": ["Vanilla Marshmallow", "Dream", "Eau de Parfum"],
    "Noir And Caramel Obsession Bundle (Value $170)": ["Noir & Caramel", "Obession", "Bundle"],
    "Oud Amber Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["Oud Amber", "Pour Homme", "Eau de Toilette"],
    "Outlaw Eau de Toilette Spray 100ml/3.4oz": ["Outlaw", "Pour Homme", "Eau de Toilette"],
    "Paris Bleu 3 in 1 Men's Wash Face Hair Body 34oz/934ml": ["Paris Bleu", "Pour Homme", "3 in 1 Body Care"],
    "Paris Bleu 365 Essentials Bundle (Value $143)": ["Paris Bleu", "365 Essentials", "Bundle"],
    "Paris Bleu Amber Eau de Toilette Spray 100ml/3.4oz": ["Paris Bleu Amber", "Pour Homme", "Eau de Toilette"],
    "Paris Bleu Body Spray 6oz/170g": ["Paris Bleu", "Pour Homme", "Body Spray"],
    "Paris Bleu Deodorant 2.8oz/80g": ["Paris Bleu", "Pour Homme", "Deodorant Stick"],
    "Paris Bleu Eau de Toilette Spray 100ml/3.4oz or 180ml/6.0oz": ["Paris Bleu", "Pour Homme", "Eau de Toilette"],
    "Paris Bleu Noir Eau de Toilette Spray 50ml/1.7oz": ["Paris Bleu Noir", "Pour Homme", "Eau de Toilette"],
    "Paris Bleu Platinum Eau de Toilette Spray 180ml/6.0oz": ["Paris Bleu Platinum", "Pour Homme", "Eau de Toilette"],
    "Paris Bleu Pour Homme Eau de Parfum Spray 100ml/3.4oz": ["Paris Bleu", "Pour Homme", "Eau de Parfum"],
    "Paris Bleu Signature Bundle (Value $108)": ["Paris Bleu Siganture", "Bundle", ""],
    "Paris Bleu Vetiver Eau de Toilette Spray 100ml/3.4oz": ["Paris Bleu Vetiver", "Pour Homme", "Eau de Toilette"],
    "Parisian Date Night Bundle (Value $164)": ["Parisian Date Night", "Bundle", ""],
    "Phantom Eau de Parfum Spray 3.4oz / 100ml": ["Phantom", "Pour Homme", "Eau de Parfum"],
    "Pink Apple Eau de Parfum 100ml/3.4oz": ["Pink Apple", "Eau de Parfum", ""],
    "Pink Honey Love Eau de Parfum Spray 100 ml / 3.4 fl oz": ["Pink Honey Love", "Eau de Parfum", ""],
    "Pink Kiss Eau de Parfum Spray 100ml/3.4oz": ["Pink Kiss", "Eau de Parfum", ""],
    "Pink Velvet Eau de Parfum 100ml/3.4oz": ["Pink Velvet", "Eau de Parfum", ""],
    "Platinum Power Bundle (Value $220)": ["Platinum Power", "Bundle", ""],
    "Power Up Bundle (Value $108)": ["Power Up", "Bundle", ""],
    "Salt & Wood Vetiver & Santal Eau de Parfum Intense Spray 100 ml / 3.4 fl oz": ["Salt & Wood", "Eau de Parfum", "Intense"],
    "Santal Vanilla Eau de Parfum Spray 100 ml / 3.4 fl oz": ["Santal Vanilla", "Eau de Parfum", ""],
    "Sexy Black Vanilla Spice Pour Homme Eau de Toilette 100ml/3.4oz": ["Sexy", "Black Vanilla Spice", "Eau de Toilette"],
    "Sexy Black Vanilla Woods Pour Homme Eau de Toilette 100ml/3.4oz": ["Sexy", "Black Vanilla Woods", "Eau de Toilette"],
    "Sexy Duo Bundle (Value $115)": ["Sexy Duo", "Bundle", ""],
    "Sexy Eau de Parfum 100ml/3.4oz": ["Sexy", "Eau de Parfum", ""],
    "Sexy Kiss Eau de Parfum Spray 100ml/3.4oz": ["Sexy Kiss", "Eau de Parfum", ""],
    "Sexy Love Secret Eau de Parfum Spray 100ml/3.4oz": ["Sexy Love Secret", "Eau de Parfum", ""],
    "Sexy RED Pour Homme Eau de Toilette Spray 3.4oz / 100ml": ["Sexy RED", "Pour Homme", "Eau de Toilette"],
    "Sexy Secret 3-D Faux Mink Long Full Lashes - 5 Pairs": ["Sexy Secret", "3-D Faux Mink Long", "Lashes Set"],
    "Sexy Secret Bliss Eau de Parfum Spray 50ml/1.7oz": ["Sexy Secret Bliss", "Eau de Parfum", ""],
    "Sexy Secret Body Spray 236ml/8oz": ["Sexy Secret", "Body Spray", ""],
    "Sexy Secret Collection Bundle (Value $425)": ["Sexy Secret", "Collection Bundle", ""],
    "Sexy Secret Divine Duo Bundle (Value $170)": ["Sexy Secret Divine", "Bundle", ""],
    "Sexy Secret Eau de Parfum Spray 50ml/1.7oz or 100ml/3.4oz": ["Sexy Secret", "Eau de Parfum", ""],
    "Sexy Secret Extreme Pour Homme Eau de Toilette Spray 50ml/1.7oz": ["Sexy Secret Extreme", "Pour Homme", "Eau de Toilette"],
    "Sexy Secret Goddess Eau de Parfum 100ml/3.4oz": ["Sexy Secret Goddess", "Eau de Parfum", ""],
    "Sexy Secret Heat Pour Homme Eau de Toilette Spray 3.4oz / 100ml": ["Sexy Secret Heat", "Pour Homme", "Eau de Toilette"],
    "Sexy Secret Iconic Bundle (Value $170)": ["Sexy Secret Iconic", "Bundle", ""],
    "Sexy Secret Love On The Go Bundle (Value $138)": ["Sexy Secret", "Love On The Go", "Bundle"],
    "Sexy Secret Noir Body Mist 236ml / 8 fl oz": ["Sexy Secret Noir", "Body Mist", ""],
    "Sexy Secret Noir Eau de Parfum 2-Piece Gift Set": ["Sexy Secret Noir", "Eau de Parfum", "Gift Set"],
    "Sexy Secret Noir Eau de Parfum Spray 50ml/1.7oz or 100ml/3.4oz": ["Sexy Secret Noir", "Eau de Parfum", ""],
    "Sexy Secret Noir Pour Homme Eau de Toilette Spray 50ml/1.7oz": ["Sexy Secret Noir", "Pour Homme", "Eau de Toilette"],
    "Sexy Secret Pour Homme Eau de Toilette Spray 50ml/1.7oz or 100ml/3.4oz": ["Sexy Secret", "Pour Homme", "Eau de Toilette"],
    "Sexy Secret Temptations Eau de Parfum Spray 50ml/1.7oz or 100ml/3.4oz": ["Sexy Secret", "Temptations", "Eau de Parfum"],
    "Sexy Sexy Body Mist 236ml/8.0oz": ["Sexy Sexy", "Body Mist", ""],
    "Sexy Sexy Eau de Parfum Spray 100ml/3.4oz": ["Sexy Sexy", "Eau de Parfum", ""],
    "Sexy Sexy Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["Sexy Sexy", "Pour Homme", "Eau de Toilette"],
    "Sexy Sweet Eau de Parfum Spray 100ml/3.4oz": ["Sexy Sweet", "Eau de Parfum", ""],
    "Sexy Sweet Kisses Eau de Parfum Spray 100ml/3.4oz": ["Sexy Sweet Kisses", "Eau de Parfum", ""],
    "Sexy Tonight Eau de Parfum Spray 100ml/3.4oz": ["Sexy Tonight", "Eau de Parfum", ""],
    "Sexy Vanilla Blackberry Eau de Parfum Spray 100 ml / 3.4 fl oz": ["Sexy Vanilla", "Blackberry", "eau de Parfum"],
    "Sexy Vanilla Body Mist 236ml / 8oz": ["Sexy Vanilla", "Body Mist", ""],
    "Sexy Vanilla Cherry Eau de Parfum Spray 100ml/3.4oz": ["Sexy Vanilla Cherry", "Eau de Parfum", ""],
    "Sexy Vanilla Eau de Parfum Spray 100ml/3.4oz": ["Sexy Vanilla", "Eau de Parfum", ""],
    "Sexy Vanilla Marshmallow EDP Spray 3.4oz / 100ml": ["Sexy Vanilla", "Marshmallow", "Eau de Parfum"],
    "Sexy Vanilla Smoke Eau de Parfum Intense 100 ml / 3.4 fl oz": ["Sexy Vanilla Smoke", "Intense", "Eau de Parfum"],
    "Sexy Vanilla Woods Eau de Parfum Intense 100 ml / 3.4 fl oz": ["Sexy Vanilla Woods", "Intense", "Eau de Parfum"],
    "Sexy Wild Vanilla Eau de Parfum Spray 100ml/3.4oz": ["Sexy Wild Vanilla", "Eau de Parfum", ""],
    "Smoked Leather Eau de Parfum spray l00 ml / 3.4 fl oz": ["Smoked Leather", "Eau de Parfum", ""],
    "Spill The Tea Bundle (Value $170)": ["Spill The Tea", "Bundle", ""],
    "Steel Intense Pour Homme Eau de Parfum Spray 100ml/3.4oz": ["Steel Intense", "Pour Homme", "Eau de Toilette"],
    "Steel Pour Homme Eau de Parfum Spray 100ml/3.4oz": ["Steel", "Pour Homme", "Eau de Parfum"],
    "Sweet Talk Eau de Parfum 100ml/3.4oz": ["Sweet Talk", "Eau de Parfum", ""],
    "Temptation RED Pour Homme EDP Spray 3.4oz / 100ml": ["Temptation RED", "Pour Homme", "Eau de Parfum"],
    "The City Of Love Bundle (Value $164)": ["The City Of Love", "Bundle", ""],
    "The Sexy Man Bundle (Value $164)": ["The Sexy Man", "Bundle", ""],
    "Thrill Seeker Bundle (Value $158)": ["Thrill Seeker", "Bundle", ""],
    "Vanilla Leather Oud Eau de Parfum 100 ml/3.4 Fl oz": ["Vanilla Leather Oud", "Eau de Parfum", ""],
    "Vanilla Shake Eau de Parfum Spray 100 ml / 3.4 fl oz": ["Vanilla Shake", "Eau de Parfum", ""],
    "Velvet Rose Eau de Parfum Spray 100 ml / 3.4 fl oz": ["Velvet Rose", "Eau de Parfum", ""],
    "Vintage Reserve Eau de Parfum 100 ml/ 3.4 fl oz": ["Vintage Reserve", "Eau de Parfum", ""],
    "White Water Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["White Water", "Pour Homme", "Eau de Toilette"],
    "Wild West Bundle (Value $158)": ["Wild West", "Bundle", ""],
    "With Love From Paris Eau de Parfum Spray 50ml/1.7oz": ["With Love From Paris", "Eau de Parfum", ""],
    "X Man Elixir Eau de Toliette 100 ml / 3.4 fl oz": ["X-Man Elixir", "Eau de Toilette", ""],
    "X-Man Elixir Eau de Toilette 100 ml / 3.4 fl oz": ["X-Man Elixir", "Eau de Toilette", ""],
    "X-Man Pour Homme Deodorant 2.8oz/80g": ["X-Man", "Pour Homme", "Deodorant Stick"],
    "X-Man Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["X-Man", "Pour Homme", "Eau de Toilette"],
    "X-Man Stealth Pour Homme Eau de Toilette Spray 100ml/3.4oz": ["X-Man Stealth", "Pour Homme", "Eau de Toilette"],
    "Yves Henri Fleur Sensuelle 3.4 oz / 100ml Eau de Parfum": ["Yves Henri Rose", "Fleur Sensuelle", "Eau de Parfum"],
    "Yves Henri Rose de Mai 3.4 oz / 100ml Eau de Parfum": ["Yves Henri Rose", "De Mai", "Eau de Parfum"],
  };

  /* Formatting applies only to the main collection products. */
const scope = '.card-product';
  const selector = scope + ' .card__heading > a.x-card-title';
  const decoder = document.createElement('textarea');

  /*
   * Tolerates capitalization, accents, punctuation, hidden breaks,
   * repeated spaces and "100 ml" versus "100ml".
   * No approximate matching between different products.
   */
  function canonicalize(value) {
    decoder.innerHTML = String(value || '');

    return decoder.value
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u200B-\u200D\uFEFF]/g, ' ')
      .toLowerCase()
      .replace(/(\d)\s+(ml|oz|g)\b/g, '$1$2')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  const titles = new Map(
    Object.entries(RAW_TITLE_LINES).map(([title, lines]) => [
      canonicalize(title),
      lines
    ])
  );

  const unmatched = new Set();
  const rendered = new WeakMap();
  const originalMargins = new WeakMap();
  let frame = 0;

  function renderTitle(link) {
    const original = link.dataset.jmpOriginalTitle;

    if (!original) return;

    const variant = link.dataset.jmpVariantTitle || '';
    const lines = titles.get(canonicalize(original));
    const signature = JSON.stringify([original, variant, lines]);

    if (
      rendered.get(link) === signature &&
      link.querySelector(':scope > .jmp-title-copy')
    ) {
      return;
    }

    const wrapper = document.createElement('span');
    wrapper.className = 'jmp-title-copy';

    if (lines) {
      for (let i = 0; i < 3; i++) {
        const row = document.createElement('span');
        row.className = 'jmp-title-line';
        row.textContent = lines[i] || '\u00A0';

        if (!lines[i]) {
          row.setAttribute('aria-hidden', 'true');
        }

        wrapper.appendChild(row);
      }
    } else {
      /* Unlisted products retain their original names. */
      wrapper.textContent = original;
      unmatched.add(original);
    }

    link.replaceChildren(wrapper);
    link.classList.add('jmp-collection-title');

    /* Keep split-card variant details separate from the approved rows. */
    if (variant) {
      const detail = document.createElement('span');
      detail.className = 'jmp-title-variant';
      detail.textContent = variant;
      link.appendChild(detail);
    }

    link.setAttribute(
      'aria-label',
      [...(lines || [original]), variant].filter(Boolean).join(' ')
    );

    rendered.set(link, signature);
  }

  function visible(element) {
    return element &&
      element.getBoundingClientRect().width > 0 &&
      element.getBoundingClientRect().height > 0;
  }

  /*
   * Equalize title blocks and align the persistent buttons within
   * each visible grid row. Long names remain readable and can wrap.
   */
  function alignCards(grid) {
    const cards = Array.from(grid.children)
      .filter(item => item.classList.contains('grid-item'))
      .map(item => item.querySelector('.card-product'))
      .filter(Boolean);

    const groups = [];

    /* Reset our previous spacing before measuring the current layout. */
    cards.forEach(card => {
      card.querySelectorAll('.jmp-title-copy').forEach(title => {
        title.style.minHeight = '';
      });

      card.querySelectorAll('.persistent-card-atc').forEach(atc => {
        if (!originalMargins.has(atc)) {
          originalMargins.set(atc, atc.style.marginTop);
        }

        atc.style.marginTop = originalMargins.get(atc);
      });
    });

    cards.filter(visible).forEach(card => {
      const top = card.getBoundingClientRect().top;
      let group = groups.find(row => Math.abs(row.top - top) < 3);

      if (!group) {
        group = { top, cards: [] };
        groups.push(group);
      }

      group.cards.push(card);
    });

    groups.forEach(group => {
      const headings = group.cards
        .map(card =>
          Array.from(card.querySelectorAll('.jmp-title-copy'))
            .find(visible)
        )
        .filter(Boolean);

      if (headings.length) {
        const height = Math.max(
          ...headings.map(title => title.getBoundingClientRect().height)
        );

        headings.forEach(title => {
          title.style.minHeight = height + 'px';
        });
      }

      const buttons = group.cards.map(card => {
        const atc = Array.from(
          card.querySelectorAll('.persistent-card-atc')
        ).find(visible);

        return atc ? {
          atc,
          top: atc.getBoundingClientRect().top,
          margin: parseFloat(getComputedStyle(atc).marginTop) || 0
        } : null;
      }).filter(Boolean);

      if (buttons.length < 2) return;

      const lowestTop = Math.max(...buttons.map(button => button.top));

      buttons.forEach(button => {
        button.atc.style.marginTop =
          button.margin +
          Math.max(0, lowestTop - button.top) +
          'px';
      });
    });
  }

  function refresh() {
  frame = 0;

  document.querySelectorAll(selector).forEach(renderTitle);

  // Keep button alignment specific to the collection grid.
  document
    .querySelectorAll('.x-section-product-grid #items-grid')
    .forEach(alignCards);
}
  function schedule() {
    if (!frame) {
      frame = requestAnimationFrame(refresh);
    }
  }

  function start() {
    const style = document.createElement('style');
    style.id = 'jmp-collection-title-styles';

    style.textContent =
      scope + ' .jmp-collection-title { display:block; }' +
      scope + ' .jmp-title-copy {' +
        ' display:block; min-height:3.75em;' +
        ' line-height:1.25; font-weight:400;' +
      ' }' +
      scope + ' .jmp-title-line {' +
        ' display:block; min-height:1.25em;' +
      ' }' +
      scope + ' .jmp-title-line:first-child {' +
        ' font-weight:600;' +
      ' }' +
      scope + ' .jmp-title-variant {' +
        ' display:block; margin-top:.25em;' +
        ' line-height:1.25; font-weight:400;' +
      ' }';

    document.head.appendChild(style);
    refresh();

    /*
     * Supports filtering, pagination, infinite scrolling,
     * grid/list changes and delayed card content.
     * Our own height/margin updates are not observed.
     */
    new MutationObserver(mutations => {
  const needsRefresh = mutations.some(mutation => {
    const target = mutation.target;

    if (
      target instanceof Element &&
      (
        target.closest('.card-product') ||
        target.closest('.x-section-product-grid')
      )
    ) {
      return true;
    }

    return Array.from(mutation.addedNodes).some(node =>
      node instanceof Element &&
      (
        node.matches('.card-product, .x-section-product-grid') ||
        node.querySelector('.card-product, .x-section-product-grid')
      )
    );
  });

  if (needsRefresh) {
    schedule();
  }
}).observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['class']
});

    window.addEventListener('resize', schedule);

    document.addEventListener('load', event => {
      if (
        event.target instanceof Element &&
        event.target.closest(scope)
      ) {
        schedule();
      }
    }, true);

    document.addEventListener('shopify:section:load', schedule);

    if (document.fonts?.ready) {
      document.fonts.ready.then(schedule);
    }

    window.JMPCollectionTitles = {
      refresh: schedule,
      unmatched
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();